import { z } from 'zod';
import type { EnvType } from '../alive/aliveResponse';

/** The most bytes a PDF study material may be (QZ-D69). */
export const MATERIAL_MAX_BYTES = 20 * 1024 * 1024;

/** The most pages a PDF study material may have (PDG-D1). */
export const MATERIAL_MAX_PAGES = 600;

/** How many days a PDF study material is kept before it expires (QZ-D71). */
export const MATERIAL_RETENTION_DAYS = 90;

/** A PDF study material's object key: `material/<uuid>.pdf`, lower-case as `randomUUID` mints (PDG-D7). */
export const materialKeySchema = z
  .string()
  .regex(/^material\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.pdf$/);

/** The object key for a PDF study material minted with id `id` (PDG-D7). */
export const newMaterialKey = (id: string): string => `material/${id}.pdf`;

/** The study material bucket's name for an environment; `local` shares dev's bucket (PDG-D8). */
export const materialBucketName = (envType: EnvType): string =>
  `quizdb-${envType === 'local' ? 'dev' : envType}-material`;
